import React from "react";
import styles from "./divider_line.module.css";

export default function () {
  return <div className={styles.divider_line} />;
}
